import { render } from "./AddPetSchedule.vue?vue&type=template&id=2efb0c45&scoped=true"
import script from "./AddPetSchedule.vue?vue&type=script&lang=js"
export * from "./AddPetSchedule.vue?vue&type=script&lang=js"

import "./AddPetSchedule.vue?vue&type=style&index=0&id=2efb0c45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb0c45"]])

export default __exports__